<template>
	<v-card height="100%">
		<!-- <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs> -->
		<v-card-text class="pt-0">
			<v-row dense>
				<!-- 日历表 -->
				<v-col cols="12" class="mt-1">
					<v-sheet height="64" min-width="1100">
						<v-toolbar color="info" flat>
						<!-- 	<v-btn class="mr-4" color="white darken-2" @click="type = 'month'">
								返回
							</v-btn> -->
							<div style="width: 230px;  height: 50px;" class="pt-1">
								<v-autocomplete :items="selectTeacherList" v-model="query.teacher" item-text="trueName" color="white"
									item-value="id" label="老师" dense outlined clearable @change="getScheduleData"></v-autocomplete>
							</div>	
							
							<v-spacer></v-spacer>
							<v-btn fab text small color="grey darken-2" @click="prev">
								<v-icon color="white">
									mdi-chevron-left
								</v-icon>
							</v-btn>
							<v-toolbar-title v-if="$refs.calendar">
								<span style="color:white">{{ $refs.calendar.title }}</span>
							</v-toolbar-title>
							<v-btn fab text small color="grey darken-2" @click="next">
								<v-icon color="white">
									mdi-chevron-right
								</v-icon>
							</v-btn>

							<!-- <v-toolbar-title>
								<span style="color:white">课程表</span>
							</v-toolbar-title> -->
							<v-spacer></v-spacer>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="shopStop.show=true">
								停课设置
							</v-btn>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="setToday">
								返回
							</v-btn>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="getScheduleData">
								刷新
							</v-btn>
							<v-btn outlined class="mr-4 ml-2" color="white darken-2" @click="toWeek">
								周课表
							</v-btn>
							<!-- <v-menu bottom right>
								<template v-slot:activator="{ on, attrs }">
									<v-btn outlined color="white darken-2" v-bind="attrs" v-on="on">
										<span>{{ typeToLabel[type] }}</span>
										<v-icon right>
											mdi-menu-down
										</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item @click="type = 'day'">
										<v-list-item-title>按日</v-list-item-title>
									</v-list-item>
									<v-list-item @click="type = 'week'">
										<v-list-item-title>按周</v-list-item-title>
									</v-list-item>
									<v-list-item @click="type = 'month'">
										<v-list-item-title>按月</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu> -->
						</v-toolbar>
					</v-sheet>
					<v-sheet height="1100" min-width="1100">
						<!-- <v-calendar ref="calendar" v-model="focus" color="light" :event-color="getEventColor"
							:type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay"
							:weekdays="weekDays" locale="zhHans" :short-intervals="false" event-more-text="查看更多"
							@change="updateRange"> -->
						<v-calendar ref="calendar" v-model="focus" color="purple lighten-3"
							:type="type"  @click:date="dayClicked"
							:weekdays="weekDays" locale="zhHans" :short-intervals="false" event-more-text="查看更多"
							@change="updateRange">
							
							<template v-slot:day="{ past, date }">
								<!-- 当日有数据 -->
								<template v-if="dateDataMap[date]">
									<!-- 每一条数据 -->
									<div class="d-flex flex-wrap" style="position: relative;">
										<v-chip v-if="dateDataMap[date].length>4" small style="position: absolute;right:10px;top: -30px;" @click="dayClicked({date})">
											共{{dateDataMap[date].length}}节
										</v-chip>
										<v-sheet width="150px" height="40px" tile class="d-flex mb-1 ml-2" 
											v-for="(item,index) in dateDataMap[date]" :key="index" @click="viewRecord(item)">
											<div style="height:40px;width: 5px; border-radius: 5px 0 0 5px;" :class="divHeaderClass(item)"></div>
											<div class="d-flex flex-column item_content">
												<div class="ml-1">
													<span>{{item.teacherName}}</span>
													<span class="ml-1">{{item.timeFrom}}-{{item.timeTo}}</span>
												</div>
												<div class="mt-n1 ml-1" style="overflow:hidden">
													<span>{{item.className}}</span>
												</div>
											</div>
										</v-sheet>
									</div>
								</template>
							</template>

						</v-calendar>

					</v-sheet>
				</v-col>
			</v-row>

		</v-card-text>
		
		<!-- 课程详情组件 -->
		<recordInfoView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false"></recordInfoView>
		<!-- 日排课明细 -->
		<dayRecordList :show="dayRecordListView.show" :classDate="dayRecordListView.classDate" @cancel="dayRecordListView.show=false"></dayRecordList>
		<!-- 停课设置 -->
		<setShopStopDate :show="shopStop.show" @cancel="shopStop.show=false" @success="setShopStopSuccess"></setShopStopDate>
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import recordInfoView from "../../../components/record_info_view.vue"
	import dayRecordList from "../../../components/day_record_list.vue"
	import setShopStopDate from "../../../components/set_shop_stop_date.vue"
	export default {
		name: "schedule-list",
		components:{recordInfoView,dayRecordList,setShopStopDate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '课程表',
						disabled: true
					},
				],

				selectTeacherList: [], //选择老师数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					teacher: "",
				},
				focus: '',
				type: 'month',
				typeToLabel: {
					month: '按月',
					week: '按周',
					day: '按日',
				},
				weekDays: [1, 2, 3, 4, 5, 6, 0],
				selectedEvent: {},
				selectedElement: null,
				selectedOpen: false,
				events: [],
				dateDataMap: {},// 每日数据
				recordView:{
					show:false,
					recordId:""
				},
				dayRecordListView:{
					show:false,
					classDate:""
				},
				shopStop:{
					show:false
				}

			}
		},
		created() {
			// 获取门店列表
			this.getTeacherListForSelect();
		},
		mounted() {
			this.$refs.calendar.checkChange()
		},
		methods: {
			toWeek(){
				this.$router.push('/edu/week/schedule');
			},
			viewRecord(item){
				this.recordView.recordId = item.id;
				this.recordView.show=true;
			},
			setShopStopSuccess(){
				this.shopStop.show = false;
				this.getScheduleData();
				
			},
			getTeacherListForSelect() {

				const shopId = utils.getCurrentShopId();


				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			divHeaderClass(item){
				let result = "";
				if (item.status == '1'){
					result = "wait_approve_header";
				}else if (item.status =='2'){
					result = "approved_header";
				}else if (item.status =='3'){
					result = "delay_header";
				}
				return result;
			},
			viewDay({
				date
			}) {
				this.focus = date;
				this.type = 'day';
				this.$refs.calendar.scrollToTime('08:00');
			},
			dayClicked({
				date
			}){
				console.log("clicked date:",date);
				this.dayRecordListView.classDate = date;
				this.dayRecordListView.show = true;
			},
			getEventColor(event) {
				return event.color
			},
			setToday() {
				this.focus = ''
			},
			prev() {
				this.$refs.calendar.prev()
			},
			next() {
				this.$refs.calendar.next()
			},
			showEvent({
				nativeEvent,
				event
			}) {

				//console.log("event:",event);
				//TODO 改为弹窗

				const open = () => {
					this.selectedEvent = event
					this.selectedElement = nativeEvent.target
					requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
				}

				if (this.selectedOpen) {
					this.selectedOpen = false
					requestAnimationFrame(() => requestAnimationFrame(() => open()))
				} else {
					open()
				}

				nativeEvent.stopPropagation()
			},
			updateRange({
				start,
				end
			}) {
				this.query.start = start.date;
				this.query.end = end.date;

				this.getScheduleData();

			},
			getScheduleData() {
				// 获取数据
				const shopId = utils.getCurrentShopId();
				const that = this;
				
				let url = `/edu/schedule/record/list/date/${this.query.start}/${this.query.end}?v=1`
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}

				console.log(url);

				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {

						const dataList = response.data["data"];
						
						console.log(">>>>>>>>>>>>>>获取日历数据>>>>>>>>>>>>>>");
						console.log(dataList);
						console.log(">>>>>>>>>>>>>>获取日历数据>>>>>>>>>>>>>>")
						that.dateDataMap = dataList;
						// const events = []

						// dataList.forEach((item, index) => {

						// 	let eventColor = "primary";
						// 	let statusName = ""
						// 	if (item.status == '1') {
						// 		//待核销
						// 		eventColor = "primary";
						// 		statusName = "待核销";
						// 	} else if (item.status == '0') {
						// 		//已取消
						// 		eventColor = "error";
						// 		statusName = "已取消";
						// 	} else if (item.status == '2') {
						// 		//已核销
						// 		eventColor = "success";
						// 		statusName = "已核销";
						// 	} else if (item.status == '3') {
						// 		//已顺延
						// 		eventColor = "grey";
						// 		statusName = "已顺延";
						// 	}


						// 	let detailHtml = "时间:" + item.classDate + " " + item.timeFrom + "-" + item
						// 		.timeTo + "<br/>";
						// 	detailHtml = detailHtml + "课程:" + item.courseName + "<br/>";
						// 	detailHtml = detailHtml + "班级:" + item.className + "<br/>";
						// 	detailHtml = detailHtml + "老师:" + item.teacherName + "<br/>";
						// 	detailHtml = detailHtml + "教室:" + item.roomName + "<br/>";
						// 	detailHtml = detailHtml + "状态:" + statusName + "<br/>";

						// 	events.push({
						// 		name: item.teacherName + "/" + item.className,
						// 		start: new Date(`${item.classDate}T${item.timeFrom}`),
						// 		end: new Date(`${item.classDate}T${item.timeTo}`),
						// 		color: eventColor,
						// 		timed: true,
						// 		details: detailHtml,
						// 		record: item

						// 	})

						// })

						// that.events = events

						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.wait_approve_header{
		background:#42A5F5; 
	}
	.approved_header{
		background:#66BB6A; 
	}
	.delay_header{
		background:#9E9E9E; 
	}
	.item_content{
		border: solid 1px #EEEEEE; 
		border-left: 0; 
		border-radius: 0 5px 5px 0; 
		font-size: 12px; 
		background:#f7f8fa; 
		cursor: pointer; 
		width:90%
	}
</style>
